(function () {
  if (customElements.get('curl-climb-game')) return;

  var STORE_KEY = 'naturall-curl-climb-best';
  var COLORS = ['#BFDDF5', '#B9B0CF', '#ECD5DB', '#9DBC90', '#F8D2CA', '#F3E0A1'];
  var INK = '#173F2D';
  var SIZE = 400;
  var GROUND = 318;
  var IVY_X = 84;
  var IVY_R = 24;
  var GRAVITY = 1900;
  var JUMP = -640;

  function storeKey(player) { return player ? STORE_KEY + ':' + player : STORE_KEY; }
  function readBest(player) {
    try { return parseInt(window.localStorage.getItem(storeKey(player)), 10) || 0; } catch (e) { return 0; }
  }
  function saveBest(value, player) {
    try { window.localStorage.setItem(storeKey(player), String(value)); } catch (e) {}
    document.querySelectorAll('curl-climb-game[data-player="' + (player || '') + '"] [data-best]').forEach(function (el) { el.textContent = value; });
  }

  class CurlClimbGame extends HTMLElement {
    connectedCallback() {
      this.canvas = this.querySelector('canvas');
      if (!this.canvas || this.ctx) return;
      this.ctx = this.canvas.getContext('2d');
      this.steps = (this.dataset.steps || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      this.player = this.dataset.player || '';
      this.best = readBest(this.player);
      if (this.player && this.best === 0 && readBest('') > 0) {
        this.best = readBest('');
        saveBest(this.best, this.player);
      }
      this.querySelectorAll('[data-best]').forEach(function (el) { el.textContent = this.best; }, this);
      this.font = getComputedStyle(document.body).fontFamily || 'sans-serif';
      this.state = 'idle';
      this.face = null;
      this.reset();

      this.onFrame = this.onFrame.bind(this);
      this.resize = this.resize.bind(this);
      this.resize();
      window.addEventListener('resize', this.resize);

      var self = this;
      this.canvas.addEventListener('pointerdown', function (event) {
        event.preventDefault();
        self.press();
      });
      this.canvas.addEventListener('keydown', function (event) {
        if (event.key === ' ' || event.key === 'ArrowUp' || event.key === 'Enter') {
          event.preventDefault();
          self.press();
        }
      });
      var play = this.querySelector('[data-play]');
      if (play) {
        play.addEventListener('click', function () {
          self.canvas.focus({ preventScroll: true });
          if (self.state !== 'running') self.press();
        });
      }

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) self.loadFace();
            else if (self.state === 'running') self.pause();
          });
        }, { rootMargin: '200px' });
        this.observer.observe(this);
      } else {
        this.loadFace();
      }
      document.addEventListener('visibilitychange', function () {
        if (document.hidden && self.state === 'running') self.pause();
      });

      this.draw();
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.resize);
      if (this.observer) this.observer.disconnect();
      cancelAnimationFrame(this.raf);
    }

    loadFace() {
      if (this.face || !this.dataset.face) return;
      var img = new Image();
      var self = this;
      img.onload = function () { self.face = img; if (self.state !== 'running') self.draw(); };
      img.src = this.dataset.face;
    }

    resize() {
      var ratio = Math.min(window.devicePixelRatio || 1, 2);
      var width = this.canvas.clientWidth || SIZE;
      this.canvas.width = Math.round(width * ratio);
      this.canvas.height = Math.round(width * ratio);
      this.scale = (width * ratio) / SIZE;
      if (this.state !== 'running') this.draw();
    }

    reset() {
      this.y = GROUND - IVY_R;
      this.vy = 0;
      this.jumps = 0;
      this.score = 0;
      this.speed = 230;
      this.items = [];
      this.nextGap = 260;
      this.distance = 0;
      this.scroll = 0;
      this.newBest = false;
    }

    press() {
      if (this.state === 'running') {
        if (this.jumps < 2) {
          this.vy = JUMP * (this.jumps === 0 ? 1 : 0.85);
          this.jumps += 1;
        }
        return;
      }
      if (this.state === 'over' || this.state === 'idle') this.reset();
      this.state = 'running';
      this.loadFace();
      this.last = performance.now();
      cancelAnimationFrame(this.raf);
      this.raf = requestAnimationFrame(this.onFrame);
    }

    pause() {
      this.state = 'paused';
      cancelAnimationFrame(this.raf);
      this.draw();
    }

    spawn() {
      var level = Math.floor(this.score / 10);
      var roll = Math.random();
      if (roll < 0.28) {
        this.items.push({ type: 'drop', x: SIZE + 20, y: GROUND - 90 - Math.random() * 90, r: 11, done: false });
      } else {
        var r = 15 + Math.random() * 8 + Math.min(level, 4) * 1.5;
        this.items.push({ type: 'knot', x: SIZE + r, y: GROUND - r, r: r, spin: Math.random() * 6, done: false });
        if (level >= 2 && Math.random() < 0.3) {
          this.items.push({ type: 'knot', x: SIZE + r * 3, y: GROUND - r, r: r, spin: Math.random() * 6, done: false });
        }
      }
      var minGap = Math.max(150, 230 - level * 10);
      this.nextGap = minGap + Math.random() * 170;
    }

    onFrame(now) {
      if (this.state !== 'running') return;
      var dt = Math.min((now - this.last) / 1000, 0.034);
      this.last = now;
      this.update(dt);
      this.draw();
      if (this.state === 'running') this.raf = requestAnimationFrame(this.onFrame);
    }

    update(dt) {
      this.speed = Math.min(520, 230 + this.score * 9);
      var move = this.speed * dt;
      this.scroll += move;
      this.distance += move;
      this.nextGap -= move;
      if (this.nextGap <= 0) this.spawn();

      this.vy += GRAVITY * dt;
      this.y += this.vy * dt;
      if (this.y >= GROUND - IVY_R) {
        this.y = GROUND - IVY_R;
        this.vy = 0;
        this.jumps = 0;
      }

      for (var i = this.items.length - 1; i >= 0; i--) {
        var item = this.items[i];
        item.x -= move;
        if (item.type === 'knot') item.spin += dt * 4;
        var dx = item.x - IVY_X;
        var dy = item.y - this.y;
        var hit = Math.sqrt(dx * dx + dy * dy) < item.r + IVY_R - 6;
        if (item.type === 'knot') {
          if (hit) { this.gameOver(); return; }
          if (!item.done && item.x + item.r < IVY_X - IVY_R) { item.done = true; this.score += 1; }
        } else if (hit && !item.done) {
          item.done = true;
          this.score += 2;
          this.items.splice(i, 1);
          continue;
        }
        if (item.x < -60) this.items.splice(i, 1);
      }
    }

    gameOver() {
      this.state = 'over';
      cancelAnimationFrame(this.raf);
      if (this.score > this.best) {
        this.best = this.score;
        this.newBest = true;
        saveBest(this.best, this.player);
      }
      this.draw();
    }

    draw() {
      var c = this.ctx;
      if (!c) return;
      var level = Math.floor(this.score / 10);
      var bg = COLORS[level % COLORS.length];
      c.setTransform(this.scale, 0, 0, this.scale, 0, 0);

      c.fillStyle = bg;
      c.fillRect(0, 0, SIZE, SIZE);

      // soft rolling hills
      c.fillStyle = 'rgba(255,255,255,0.35)';
      c.beginPath();
      c.moveTo(0, GROUND);
      for (var x = 0; x <= SIZE; x += 10) {
        c.lineTo(x, GROUND - 46 - Math.sin((x + this.scroll * 0.3) / 60) * 18);
      }
      c.lineTo(SIZE, GROUND);
      c.closePath();
      c.fill();

      // ground
      c.fillStyle = INK;
      c.fillRect(0, GROUND, SIZE, SIZE - GROUND);
      c.fillStyle = 'rgba(255,255,255,0.25)';
      for (var g = -(this.scroll % 40); g < SIZE; g += 40) c.fillRect(g, GROUND + 14, 18, 3);

      // items
      for (var i = 0; i < this.items.length; i++) {
        var item = this.items[i];
        if (item.type === 'knot') this.drawKnot(item);
        else this.drawDrop(item);
      }

      this.drawIvy();

      // header text
      c.fillStyle = INK;
      c.textBaseline = 'top';
      c.font = '700 18px ' + this.font;
      c.textAlign = 'left';
      var step = this.steps.length ? this.steps[level % this.steps.length] : '';
      if (step) c.fillText(step, 16, 16);
      c.textAlign = 'right';
      c.font = '700 26px ' + this.font;
      c.fillText(String(this.score), SIZE - 16, 12);

      if (this.state !== 'running') {
        c.fillStyle = 'rgba(255,255,255,0.78)';
        this.roundRect(60, 130, 280, 96, 16);
        c.fill();
        c.fillStyle = INK;
        c.textAlign = 'center';
        c.textBaseline = 'middle';
        if (this.state === 'over') {
          c.font = '700 22px ' + this.font;
          c.fillText(this.newBest ? (this.dataset.newBest || '') : String(this.score), SIZE / 2, 162);
          c.font = '400 17px ' + this.font;
          c.fillText(this.dataset.over || '', SIZE / 2, 196);
        } else {
          c.font = '700 22px ' + this.font;
          c.fillText(this.dataset.start || '', SIZE / 2, 178);
        }
      }
    }

    roundRect(x, y, w, h, r) {
      var c = this.ctx;
      c.beginPath();
      c.moveTo(x + r, y);
      c.arcTo(x + w, y, x + w, y + h, r);
      c.arcTo(x + w, y + h, x, y + h, r);
      c.arcTo(x, y + h, x, y, r);
      c.arcTo(x, y, x + w, y, r);
      c.closePath();
    }

    drawIvy() {
      var c = this.ctx;
      var squash = this.y < GROUND - IVY_R - 1 ? 1 : 1;
      c.save();
      c.translate(IVY_X, this.y);
      // shadow
      c.fillStyle = 'rgba(23,63,45,0.18)';
      var lift = (GROUND - IVY_R - this.y) / 160;
      c.beginPath();
      c.ellipse(0, GROUND - this.y - 2, IVY_R * (1 - Math.min(lift, 0.5)), 5, 0, 0, Math.PI * 2);
      c.fill();
      // curls halo
      c.fillStyle = INK;
      for (var a = 0; a < 9; a++) {
        var ang = Math.PI + (a / 8) * Math.PI;
        c.beginPath();
        c.arc(Math.cos(ang) * IVY_R * 0.95, Math.sin(ang) * IVY_R * 0.95 * squash, 9, 0, Math.PI * 2);
        c.fill();
      }
      c.beginPath();
      c.arc(0, 0, IVY_R, 0, Math.PI * 2);
      c.fillStyle = '#FFFFFF';
      c.fill();
      if (this.face) {
        c.save();
        c.beginPath();
        c.arc(0, 0, IVY_R - 2, 0, Math.PI * 2);
        c.clip();
        c.drawImage(this.face, -IVY_R, -IVY_R, IVY_R * 2, IVY_R * 2);
        c.restore();
      } else {
        c.fillStyle = '#8A5A3C';
        c.beginPath();
        c.arc(0, 2, IVY_R - 4, 0, Math.PI * 2);
        c.fill();
      }
      c.lineWidth = 3;
      c.strokeStyle = INK;
      c.beginPath();
      c.arc(0, 0, IVY_R, 0, Math.PI * 2);
      c.stroke();
      c.restore();
    }

    drawKnot(item) {
      var c = this.ctx;
      c.save();
      c.translate(item.x, item.y);
      c.rotate(item.spin);
      c.strokeStyle = INK;
      c.lineWidth = 3;
      c.lineCap = 'round';
      c.beginPath();
      for (var t = 0; t <= Math.PI * 6; t += 0.2) {
        var rad = item.r * (0.45 + 0.55 * Math.abs(Math.sin(t * 1.3)));
        var px = Math.cos(t) * rad;
        var py = Math.sin(t) * rad;
        if (t === 0) c.moveTo(px, py); else c.lineTo(px, py);
      }
      c.stroke();
      c.restore();
    }

    drawDrop(item) {
      var c = this.ctx;
      c.save();
      c.translate(item.x, item.y);
      c.fillStyle = '#FFFFFF';
      c.strokeStyle = INK;
      c.lineWidth = 2.5;
      c.beginPath();
      c.moveTo(0, -item.r * 1.5);
      c.bezierCurveTo(item.r, -item.r * 0.4, item.r, item.r, 0, item.r);
      c.bezierCurveTo(-item.r, item.r, -item.r, -item.r * 0.4, 0, -item.r * 1.5);
      c.fill();
      c.stroke();
      c.restore();
    }
  }

  customElements.define('curl-climb-game', CurlClimbGame);
})();
